import { ERROR_403_ROUTE_NAME, ERROR_404_ROUTE_NAME, ERROR_ROUTE_NAME, LOGIN_ROUTE_NAME } from '../constant'
import type { AppRoutes } from '../types'

// 认证相关路由
export const authRoutes: AppRoutes = [
  {
    path: '/Login',
    name: LOGIN_ROUTE_NAME,
    component: () => import('@/views/Login/index.vue')
  }
]

// 错误相关路由
export const errorRoutes: AppRoutes = [
  {
    path: '/404',
    name: ERROR_404_ROUTE_NAME,
    component: () => import('@/views/Error/404.vue')
  },
  {
    path: '/403',
    name: ERROR_403_ROUTE_NAME,
    component: () => import('@/views/Error/403.vue')
  }
]

// 未找到路由
export const notFoundRoutes: AppRoutes = [
  {
    path: '/:pathMatch(.*)',
    name: ERROR_ROUTE_NAME,
    redirect: '/404'
  }
]

export default [...authRoutes, ...errorRoutes]
